<template>
  <div class="num-filter">
    <el-select class="rule-item" v-model="formData.rule">
      <el-option-group v-for="group in rules" :key="group.label" :label="group.label">
        <el-option
          v-for="ruleItem in group.options"
          :key="ruleItem.value"
          :value="ruleItem.value"
          :label="ruleItem.label"
        />
      </el-option-group>
    </el-select>

    <template v-if="isDuplicateCount">
      <el-select class="form-li-item" v-model="formData.symbol" placeholder="请选择">
        <el-option value=">" label="大于" />
        <el-option value="<" label="小于" />
        <el-option value=">=" label="大于等于" />
        <el-option value="<=" label="小于等于" />
        <el-option value="=" label="等于" />
      </el-select>

      <el-input-number
        v-model="formData.num"
        class="form-li-item"
        placeholder="请输入数值"
        :min="0"
        :max="10000000"
        :precision="0"
        :controls="false"
      />
    </template>

    <div class="range-content" v-show="!isDuplicateCount && isRange">
      <el-input-number class="input-num-item" v-model="formData.numArr[0]" :controls="false" :precision="2" />
      <span :style="{ margin: '0 5px' }">至</span>
      <el-input-number class="input-num-item" v-model="formData.numArr[1]" :controls="false" :precision="2" />
    </div>

    <el-input-number
      v-show="!isDuplicateCount && !isRange && !isExistsRule"
      :style="{ marginLeft: '5px' }"
      class="input-num-item"
      v-model="formData.num"
      :controls="false"
      :precision="2"
    />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  data() {
    return {
      formData: null
    };
  },
  props: {
    defaultFormData: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    defaultDataStatic() {
      return {
        rule: this.rules[0].options[0].value,
        num: undefined,
        numArr: [undefined, undefined],
        fieldCount: undefined,
        symbol: '>'
      };
    },
    rules() {
      const normalRules = [
        { value: 'DUPLICATE_COUNT', label: '重复项计数' },
        { value: 'MONODROME', label: '单值' },
        { value: 'MULTIVALUED', label: '多值' },
        { value: 'term', label: '等于' },
        { value: 'gt', label: '大于' },
        { value: 'lt', label: '小于' },
        { value: 'gte', label: '大于等于' },
        { value: 'lte', label: '小于等于' },
        { value: 'exists_not', label: '数值为空' },
        { value: 'exists', label: '数值不为空' },
        { value: 'range', label: '区间' },
        { value: 'lrange', label: '区间(左等)' },
        { value: 'rrange', label: '区间(右等)' },
        { value: 'erange', label: '区间(全等)' }
      ];
      return [{ label: '数值筛选', options: normalRules }];
    },
    isRange() {
      return ['range', 'lrange', 'rrange', 'erange'].includes(this.formData.rule);
    },
    isExistsRule() {
      return ['exists', 'exists_not', 'MONODROME', 'MULTIVALUED'].includes(this.formData.rule || '');
    },
    isDuplicateCount() {
      return this.formData.rule === 'DUPLICATE_COUNT';
    }
  },
  created() {
    this.formData = cloneDeep(this.defaultDataStatic);
    if (this.defaultFormData) {
      this.formData = { ...this.formData, ...this.defaultFormData };
    }
    this.$watch(
      'formData',
      () => {
        this.$emit('change');
      },
      { deep: true }
    );
  },
  methods: {
    validateInfo() {
      if (this.isDuplicateCount) {
        if (!this.formData.num && this.formData.num !== 0) {
          throw new Error('请输入重复计数值');
        }
      } else if (this.isRange) {
        if (isNaN(this.formData.numArr[0]) || isNaN(this.formData.numArr[1])) {
          throw new Error('请输入数值区间范围');
        }
      } else if (!this.isExistsRule && isNaN(this.formData.num)) {
        throw new Error('请输入数值');
      }
      return this.formData;
    }
  }
};
</script>

<style lang="scss" scoped>
.num-filter {
  height: 100%;
  display: flex;
  align-items: center;

  .rule-item {
    width: 160px;
  }

  .range-content {
    display: flex;
    align-items: center;
    margin-left: 5px;

    .input-num-item {
      width: 160px;
    }
  }

  .form-li-item {
    width: 160px;
    margin-left: 5px;
    &.search-item {
      width: 344px;
    }
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
